/*jslint browser: true, plusplus: true*/
/*global $, jQuery, alert, console, SchoolBlocksApp, moment */

import $ from "jquery";
import { interfaceStore } from "../stores/StoreLoader";

export function sb_scrollWindowTo($loc) {
    require("velocity-animate");
    var offset = 0;

    if ($loc === undefined) {
        $loc = $('html');
    }

    if ($loc.hasClass('sb-block')) {
        offset = -200;
    }

    // Scroll to the top of the page after the drawer opens
    $loc.velocity("scroll", {
        'duration': 500,
        'mobileHA': false,
        'offset': offset
    });
}

export function sb_velocityCloseRightDrawer() {
    require("velocity-animate");
    var drawer = $('.sb-right-drawer'),
        drawerOpenClass = 'open',
        mainContent = $('#sb-content-canvas .sb-main-content'),
        topDrawers = $('.sb-top-drawer');

    if (!drawer.hasClass(drawerOpenClass)) {
        return;
    }

    drawer.velocity({
        'left': '+=' + drawer.data("shifted-left") + 'px'
    }, {
        'visibility': 'hidden',
        'duration': 300,
        complete: function () {
            drawer.removeClass(drawerOpenClass);
            drawer.trigger("transitionend");
        }
    });

    mainContent.add(topDrawers).velocity({
        'left': '+=' + mainContent.data("shifted-left") + 'px'
    }, {
        'duration': 300,
        complete: function () {
            mainContent.trigger("transitionend");
            $(window).trigger("poi.set-point-location");
        }
    });

}

export function sb_velocityOpenRightDrawer() {
    var drawer = $('.sb-right-drawer'),
        drawerSize = drawer.outerWidth(),
        drawerPosition,
        drawerOpenClass = 'open',
        mainContent = $('#sb-content-canvas .sb-main-content'),
        mainContentPosition,
        mainContentRightBorder,
        shiftWidth,
        spacing = 10,
        travelDistance,
        topDrawers = $('.sb-top-drawer');

    if (drawer.hasClass(drawerOpenClass)) {
        return;
    }
    mainContentPosition = mainContent.offset();
    mainContentRightBorder = mainContentPosition.left + mainContent.outerWidth();
    drawerPosition = drawer.offset();
    shiftWidth = drawerSize / 2;
    travelDistance = drawerPosition.left - mainContentRightBorder + shiftWidth - spacing;

    if(travelDistance < drawerSize) {
        shiftWidth += drawerSize - travelDistance;
        travelDistance = drawerSize;
    }

    mainContent.data("shifted-left", (shiftWidth + spacing));
    mainContent.add(topDrawers).velocity({
        'left': '-=' + (shiftWidth + spacing) + 'px'
    }, {
        'duration': 300,
        complete: function () {
            mainContent.trigger("transitionend");
            $(window).trigger("poi.set-point-location");
        }
    });

    drawer.data("shifted-left", travelDistance);
    drawer.velocity({
        'left': '-=' + travelDistance + 'px'
    }, {
        'visibility': 'visible',
        'duration': 300,
        complete: function () {
            drawer.addClass(drawerOpenClass);
            drawer.trigger("transitionend");
        }
    });
}

export function sb_velocityToggleRightDrawer() {
    var drawer = $('.sb-right-drawer'),
        drawerOpenClass = 'open';

    if (drawer.hasClass(drawerOpenClass)) {
        sb_velocityCloseRightDrawer();
    } else {
        sb_velocityOpenRightDrawer();
    }
}

export function sb_hideAllAdminNavModals(exceptModal) {
    if (exceptModal !== 'editPage') {
        interfaceStore.stopEditingPage();
    }
}
